/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Alert } from 'sarsaparilla';

export type MfaCodeErrorType = 'invalidToken' | 'unknown' | null;

interface MfaCodeErrorsProps {
    errorType: MfaCodeErrorType;
    className?: string;
}

export function MfaCodeErrors({ errorType, className }: MfaCodeErrorsProps) {
    if (!errorType) {
        return null;
    }

    if (errorType === 'invalidToken') {
        return (
            <Alert
                type="error"
                className={className}
                heading="Invalid Code"
                shouldFocusOnMount
            >
                <p>Please double check the code and try again.</p>
                <p>
                    If you have lost access to your authenticator app and your backup
                    codes, you will need to contact support to reset your MFA. Contact
                    information can be found on the{' '}
                    <a
                        href={process.env.SN_CONTACT_EXT_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="font-weight-semibold"
                    >
                        Support
                    </a>{' '}
                    page.
                </p>
            </Alert>
        );
    }

    return (
        <Alert
            type="error"
            className={className}
            heading="Code Validation Failed"
            shouldFocusOnMount
        >
            Something went wrong while trying validate your code. Please try again in a
            moment. If the problem persists, try refreshing the page.
        </Alert>
    );
}
